export function fileSizeFormat (value: number) {
  if (!value || value == null) {
    return '0 Bytes'
  }
  const unitArr = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
  let index = 0

  index = Math.floor(Math.log(value) / Math.log(1000))
  const size = value / Math.pow(1000, index)
  const sizeStr = size.toFixed(2)
  return sizeStr + ' ' + unitArr[index]
}
